import { ISvcStatusBadge } from '@solvace/component/svc-status-badge';
import { CategorizedDrillDown } from '@solvace/core/models';

export interface InspetionDrillDownItem {
  checkListId: number;
  checkListName: string;
  checkListCreateDate: string;
  checkListStatus: number;
  isPrivate: boolean | null;
  inspectionItemsNotOk: number;
  inspectionItemsOk: number;
  inspectionItemsPending: number;
  inspectionRegistryNumber: number;
  owners?: any;
  deadline: number | null;
  age: number | null
}

export class InspetionCategorizedDrillDown implements CategorizedDrillDown<InspetionDrillDownItem> {
  indicatorEnum: number;
  indicatorItems: InspetionDrillDownItem[];
}

export enum InspectionDrillDownStatus {
  OPEN = 10,
  IN_APPROVAL = 20,
  COMPLETED = 30,
}

export const InspectionDrillDownStatusBadge = <InspectionDrillDownStatus>(enumDefinition: InspectionDrillDownStatus): ISvcStatusBadge => {
  switch (enumDefinition) {
    case InspectionDrillDownStatus.OPEN:
      return { description: 'Aberta', type: 'opened' };
    case InspectionDrillDownStatus.IN_APPROVAL:
      return { description: 'Em Aprovação', type: 'approval' };
    case InspectionDrillDownStatus.COMPLETED:
      return { description: 'Concluída', type: 'completed' };
  }
};
